import { render, staticRenderFns } from "./TipoTratamiento.vue?vue&type=template&id=d7d0c04e"
import script from "./TipoTratamiento.vue?vue&type=script&lang=ts"
export * from "./TipoTratamiento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports